import React, { useState, useEffect } from 'react';
import api from '../../../utils/api';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
// import EvaluationDocument from '../../../utils/EvaluationDocument';
import EvaluationDocumentBatchEight from '../../../utils/EvaluationDocumentBatchOne';
import EvaluationDocumentBatchNine from '../../../utils/EvaluationDocument';
import EvaluationDocumentBatchTen from '../../../utils/EvaluationDocumentBatchThree';
import { finalEvaluation } from '../../../utils/data';

const EvaluationFinal = ({ authUser }) => {
  const { batchId = 1 } = authUser?.currentlyProgram.batch || {};

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(finalEvaluation);
  const [message, setMessage] = useState();
  const [status, setStatus] = useState(true);

  useEffect(() => {
    const onHandlerGetFinalEvaluationsById = async () => {
      const { status, message, data } = await api.appGetFinalEvaluations({
        batchId,
      });
      if (status !== 'success') {
        setMessage(message);
        setStatus(false);
      }
      setData(data);
      setLoading(false);
    };

    onHandlerGetFinalEvaluationsById();
  }, []);

  const renderEvaluationDocument = () => {
    switch (batchId) {
      case 1:
        return <EvaluationDocumentBatchEight finalEvaluation={data} />;
      case 2:
        return <EvaluationDocumentBatchNine finalEvaluation={data} />;
      case 3:
        return <EvaluationDocumentBatchTen finalEvaluation={data} />;
      default:
        return <div>Invalid batch</div>;
    }
  };

  if (loading) {
    return (
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!status) {
    return <div class="d-flex justify-content-center">{message}</div>;
  }

  if (batchId === 3) {
    return (
      <div class="d-flex justify-content-center">
        <p>
          Nilai akhir magang akan diberikan secara langsung kepada dosen
          pembimbing atau perwakilan program studi pada 20 Juni 2025. Mahasiswa
          peserta Magang Mandiri Campus Leaders Program Batch 10 baru dapat
          mengakses dan melihat nilai akhir secara langsung pada tanggal 1 Juli
          2025 setelah seluruh kegiatan magang resmi berakhir.
        </p>
      </div>
    );
  }

  if (status) {
    return (
      <div className="card">
        <div className="card-body">
          {/* <PDFViewer height={700} width={650}>
            {<EvaluationDocumentBatchEight finalEvaluation={data} />}
          </PDFViewer> */}
          <div className="d-flex justify-content-between mb-3">
            <h1 className="h5">Penilaian {data?.batchId}</h1>
            <div className="col-3">
              <div className="d-flex justify-content-end">
                <div className="d-grid gap-2">
                  <PDFDownloadLink
                    className="btn btn-primary"
                    document={renderEvaluationDocument()}
                    fileName={`FINAL_EVALUATION_${data?.mentessFirstName}_${data?.mentessLastName}.pdf`}
                  >
                    {({ loading }) =>
                      loading ? (
                        <>
                          <span
                            class="spinner-border spinner-border-sm"
                            aria-hidden="true"
                          ></span>
                          <span role="status"> Loading...</span>
                        </>
                      ) : (
                        'Download'
                      )
                    }
                  </PDFDownloadLink>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-12">
              <label htmlFor="Mentess" className="form-label">
                Mentess
              </label>
              <div className="input-group has-validation">
                <input
                  disabled
                  value={`${data?.mentessFirstName} ${data?.mentessLastName}`}
                  type="text"
                  className="form-control"
                  id="Mentess"
                  placeholder="Mentess"
                />
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="Jurusan" className="form-label">
                Jurusan
              </label>
              <div className="input-group has-validation">
                <input
                  disabled
                  value={data?.universities?.universitiesMajor}
                  type="text"
                  className="form-control"
                  id="Jurusan"
                  placeholder="Jurusan"
                />
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="Universitas" className="form-label">
                Universitas
              </label>
              <div className="input-group has-validation">
                <input
                  disabled
                  value={data?.universities?.universitiesName}
                  type="text"
                  className="form-control"
                  id="Universitas"
                  placeholder="Universitas"
                />
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="Divisi" className="form-label">
                Divisi
              </label>
              <div className="input-group has-validation">
                <input
                  disabled
                  value={data?.institutions?.divisionName}
                  type="text"
                  className="form-control"
                  id="Divisi"
                  placeholder="Divisi"
                />
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="Nilai Rata-Rata" className="form-label">
                Nilai Rata-Rata
              </label>
              <div className="input-group has-validation">
                <input
                  disabled
                  value={data?.finalEvaluationAverage}
                  type="text"
                  className="form-control"
                  id="Nilai Rata-Rata"
                  placeholder="Nilai Rata-Rata"
                />
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="Nilai Akhir" className="form-label">
                Nilai Akhir
              </label>
              <div className="input-group has-validation">
                <input
                  disabled
                  value={data?.finalEvaluationTotal}
                  type="text"
                  className="form-control"
                  id="Nilai Akhir"
                  placeholder="Nilai Akhir"
                />
              </div>
            </div>

            <div className="col-12 table-responsive card p-3">
              <div className="d-flex justify-content-between mb-3">
                <h1 className="h5">Bakrie Center Foundation</h1>
              </div>
              {!data?.evaluationsBCF?.classifications?.length < 1 && (
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: 10 }} scope="col">
                        #
                      </th>
                      <th style={{ width: 350 }} scope="col">
                        KPI
                      </th>
                      <th style={{ width: 10 }} scope="col">
                        Nilai
                      </th>
                      <th scope="col">Catatan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.evaluationsBCF?.classifications?.map(
                      (value, key) => (
                        <tr key={key} style={{ cursor: 'default' }}>
                          <th scope="row">{key + 1}</th>
                          <td>{value.classification}</td>
                          <td>{value.evaluation}</td>
                          <td>{value.note}</td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              )}
            </div>

            <div className="col-12 table-responsive card p-3">
              <div className="d-flex justify-content-between mb-3">
                <h1 className="h5">Mentors</h1>
              </div>
              <table className="table table-hover">
                {!data?.evaluationsHS?.length < 1 && (
                  <>
                    <thead>
                      <tr>
                        <th style={{ width: 10 }} scope="col">
                          #
                        </th>
                        <th style={{ width: 350 }} scope="col">
                          KPI Hardskill
                        </th>
                        <th style={{ width: 10 }} scope="col">
                          Nilai
                        </th>
                        <th scope="col">Catatan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.evaluationsHS?.map((value, key) => (
                        <tr key={key} style={{ cursor: 'default' }}>
                          <th scope="row">{key + 1}</th>
                          <td>{value.classification}</td>
                          <td>{value.evaluation}</td>
                          <td>{value.note}</td>
                        </tr>
                      ))}
                    </tbody>
                  </>
                )}
                {!data?.evaluationsSS?.length < 1 && (
                  <>
                    <thead>
                      <tr>
                        <th style={{ width: 10 }} scope="col">
                          #
                        </th>
                        <th style={{ width: 350 }} scope="col">
                          KPI Softskill
                        </th>
                        <th style={{ width: 10 }} scope="col">
                          Nilai
                        </th>
                        <th scope="col">Catatan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.evaluationsSS?.map((value, key) => (
                        <tr key={key} style={{ cursor: 'default' }}>
                          <th scope="row">{key + 1}</th>
                          <td>{value.classification}</td>
                          <td>{value.evaluation}</td>
                          <td>{value.note}</td>
                        </tr>
                      ))}
                    </tbody>
                  </>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default EvaluationFinal;
